var isBrowser = typeof window !== "undefined";
var ua = isBrowser && navigator.userAgent.toLocaleLowerCase();
var isSafari = isBrowser && /^((?!chrome|android).)*safari/.test(ua);
var isFirefox = isBrowser && ua.includes("firefox");
var isAndroid = isBrowser && ua.includes("android");
export { isAndroid, isBrowser, isFirefox, isSafari };
